"use strict";

require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _drei = require("@react-three/drei");
var _reactRedux = require("react-redux");
var _reactErrorBoundary = require("react-error-boundary");
var _paulCorePackage = require("paul-core-package");
var _constants = require("../../../utils/constants");
const _excluded = ["debug"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const BoilerGasModelContent = props => {
  const {
      debug = {}
    } = props,
    p = _objectWithoutProperties(props, _excluded);
  const {
    source
  } = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getUrls);
  const {
    nodes,
    materials
  } = (0, _drei.useGLTF)("".concat(source).concat(_constants.webGLModalsSource, "/300_heating_assets/312_boiler_gas.glb"));
  const shadows = {
    castShadow: true,
    receiveShadow: false
  };
  const GasBoilerRef = (0, _react.useRef)(null);
  return /*#__PURE__*/_react.default.createElement("group", _extends({}, p, {
    ref: GasBoilerRef,
    dispose: null,
    visible: true
  }), /*#__PURE__*/_react.default.createElement("mesh", _extends({
    geometry: nodes['01_body'].geometry,
    material: materials['Component.WhiteDefault'],
    position: [0, 3.16, 0],
    scale: [8.95, 11.72, 10.75]
  }, shadows), /*#__PURE__*/_react.default.createElement("meshStandardMaterial", {
    color: "#E4E7EC",
    roughness: "0.1",
    flatShading: true
  })), /*#__PURE__*/_react.default.createElement("mesh", _extends({
    geometry: nodes['02_display'].geometry,
    material: materials['Component.EmissionBlau'],
    position: [0, 3.16, 0],
    scale: 2.81
  }, shadows), /*#__PURE__*/_react.default.createElement("meshStandardMaterial", {
    color: "#0000FF",
    roughness: "0.1",
    transparent: "true",
    opacity: "0.15"
  })));
};
const BoilerGasModel = (0, _reactErrorBoundary.withErrorBoundary)(BoilerGasModelContent, {
  FallbackComponent: () => null,
  onError: (err, info) => console.error(err, info)
});
var _default = exports.default = BoilerGasModel;